/** YYYY-MM-DD in the viewer's own timezone (toISOString is UTC). */
export function localDateStamp(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/** A readable message whether the API sent `error` as a string or an object. */
export function exportErrorMessage(body: unknown, status: number): string {
  const err = (body as { error?: unknown } | null)?.error
  if (typeof err === 'string' && err.length > 0) return err
  if (err && typeof err === 'object' && typeof (err as { message?: unknown }).message === 'string') {
    return (err as { message: string }).message
  }
  return `Export failed with status ${status}`
}
